import React    from 'react';
import Polite   from '../../../global/globalPrivacy';
import * as GV  from '../../../global/globalVariables';

function PrivacyPasswordWallet() {
    
    return (
        <>
        <Polite name={GV.APP_PASSWORD_WALLET}></Polite>
        </>
    )
}

export default PrivacyPasswordWallet;